module.exports = __webpack_public_path__ + "img/AccountsQrcode.c4b6a044.jpg";